import { Component, Input, OnInit } from '@angular/core';
import { OfferShuntersInterface } from '../../models/offer-shunters.interface';
import { PriceFormatService } from '../../services/price-format.service';

@Component({
  selector: 'app-shunters',
  templateUrl: './shunters.component.html',
  styleUrls: ['./shunters.component.css'],
  standalone: false
})
export class ShuntersComponent implements OnInit {

  @Input()
  shunters?: OfferShuntersInterface;

  @Input()
  price?: any;

  @Input()
  customPrice?: number;

  constructor(public priceFormatService: PriceFormatService) {}

  ngOnInit() {
  }

  getShuntersArray(shunters: Array<any>) {
    const shuntersArray = [];
    for (let i = 0; i < shunters.length; i++) {
      shuntersArray.push(shunters[i].toString());
      if ((i + 1) < shunters.length) {
        shuntersArray.push('');
      }
    }
    return shuntersArray;
  }

  getPrice(shunters: Array<any>, index) {
    const shuntersArray = [];
    for (let i = 0; i < shunters.length; i++) {
      shuntersArray.push(shunters[i].toString());
      if ((i + 1) < shunters.length) {
        shuntersArray.push('');
      }
    }
    return shuntersArray[index - 1];
  }

  isSelectShunter(price: any) {
    if (this.price) {
      return price === this.price.toFixed(2);
    }
    return false;
  }
}
